import { TASKS_SERVICE_URL } from "@coworker/app/src/hooks/API/tasks.service.helper";
import CloseReason from "@coworker/apprestructured/src/task-management/types/CloseReason";
import {
  createAuthorizationHeader,
  toJson,
} from "@coworker/apprestructured/src/task-management/services/fetchHelper";

const BASE_URL = `${TASKS_SERVICE_URL}/close-reasons`;

export async function getAllCloseReasons() {
  return toJson<CloseReason[]>(
    await fetch(BASE_URL, {
      method: "GET",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
    })
  );
}
